module.exports = __webpack_public_path__ + "static/media/mag-logo5.eef16438.png";